export class ContainerType {
  constructor (name) {
    this.name = name
  }

  toString () {
    return this.name
  }

  get [Symbol.toStringTag] () {
    return this.name
  }
}
ContainerType.SIMPLE = new ContainerType('SIMPLE')
ContainerType.OVERLAY = new ContainerType('OVERLAY')
ContainerType.DOCKED_BOTTOM = new ContainerType('DOCKED_BOTTOM')
ContainerType.DOCKED_RIGHT = new ContainerType('DOCKED_RIGHT')
ContainerType.DOCKED_BR = new ContainerType('DOCKED_BR')
ContainerType.STICKY = new ContainerType('STICKY')
ContainerType.HEADLINER = new ContainerType('HEADLINER')
